<template>
    <div class="lottery-wrapper v3" :class="welfareType">
        <div v-if="isMedal" class="lottery-title"></div>
        <!-- 抽奖转盘 -->
        <div class="lottery-area">
            <lottery-item
                v-for="(item,index) in prizeList"
                :key="index"
                :prize-info="item"
                class="lottery-item"
                :class="[`lottery-item-${index}`,{'choosedItem': currentIndex === index}]"
            />
            <div v-debounce="beginToDraw" class="lottery-button"></div>
        </div>
        <div v-if="isShowLackCoinsToast || isShowLackMedalsToast || isShowPrizeToast" class="toast-mask">
            <!-- 金币不足弹窗 -->
            <div v-if="isShowLackCoinsToast" class="lack-coins-toast">
                <div class="go-to-task" @click="goToTask"></div>
            </div>
            <!-- 徽章不足弹窗 -->
            <div v-else-if="isShowLackMedalsToast" class="lack-coins-toast">
                <div class="go-to-task" @click="goToKingRoadTask"></div>
            </div>
            <!-- 奖品详情弹窗 -->
            <div v-else-if="isShowPrizeToast" class="prize-toast">
                <!-- 金币 -->
                <div
                    v-if="prizeInfo.type.indexOf(prizeInfoType.coin) > -1"
                    class="prize-coin-toast"
                    :style="{backgroundImage: `url(${prizeInfo.icon})`}"
                >
                    <div class="prize-name">已获得{{ prizeInfo.name }}</div>
                </div>
                <!-- 打车券 -->
                <div
                    v-else-if="prizeInfo.type.indexOf(prizeInfoType.dachequan) > -1"
                    class="prize-coupons-toast"
                    :style="{backgroundImage: `url(${prizeInfo.icon})`}"
                >
                    <div class="coupon-toast-btn" @click="jumpToCouponPage"></div>
                </div>
                <!-- 礼品 -->
                <div
                    v-else
                    class="prize-gift-toast"
                    :style="{backgroundImage: `url(${prizeInfo.icon})`}"
                >
                    <div class="prize-name">{{ prizeInfo.name }}</div>
                </div>
            </div>
            <div class="closed-btn" @click="closeToast"></div>
        </div>
    </div>
</template>

<script>
import LotteryItem from './LotteryItem.vue';
import {mapState, mapMutations, mapActions} from 'vuex';
import {jumpByOpenapi, closeNativePage} from '@/pages/pano-game/constant/JumpFunc';
import StatisticConst from '@/pages/pano-game/constant/StatisticConst';
import Const from '@/pages/pano-game/constant/Constant';
// 判断是否初次点击抽奖
let isFirstLottery = true;
export default {
    data() {
        return {
            animationPlaying: false,
            prizeInfo: null,
            prizeInfoType: Const.prizeInfoType,
            currentIndex: -1,
            prizeIndex: -1,
            cycle: 5,
            times: 0,
            timer: null,
            speed: 100,
            isShowLackMedalsToast: false,
            isShowLackCoinsToast: false,
            isShowPrizeToast: false
        };
    },
    props: {
        prizeList: {
            type: Array,
            default: () => ([])
        },
        welfareType: {
            type: String,
            default: Const.welfareType.coin
        },
        taskListTop: {
            type: Number,
            default: 0
        }
    },
    components: {
        LotteryItem
    },
    computed: {
        ...mapState(['isMedal']),
        ...mapState('welfare', [
            'myCoin',
            'medalNum',
            'lotteryCoin',
            'lotteryMedal',
            'lotteryRemain'
        ])
    },
    methods: {
        ...mapMutations(['setMyCoin']),
        ...mapActions('welfare', ['lottery']),
        beginToDraw() {
            if (!this.animationPlaying) {
                if (this.isMedal) {
                    // 徽章判断
                    this.isShowLackMedalsToast = this.medalNum < this.lotteryMedal;
                    !this.isShowLackMedalsToast && this.getLotteryResult();
                }
                else {
                    // 金币判断
                    this.isShowLackCoinsToast = this.myCoin < this.lotteryCoin;
                    !this.isShowLackCoinsToast && this.getLotteryResult();
                }
            }
        },
        getRandomIdx() {
            if (isFirstLottery) {
                this.currentIndex = Math.floor(Math.random() * 8);
                isFirstLottery = false;
            }
        },
        // 抽奖接口
        getLotteryResult() {
            StatisticConst.lotteryClick();
            if (this.isMedal && this.lotteryRemain <= 0) {
                this.$toast('今日抽奖次数已达上限');
                return false;
            }
            this.lottery().then(resData => {
                if (resData && resData.lotteryResult === 1) {
                    this.prizeInfo = resData.prizeInfo;
                    this.prizeList.forEach((item, index) => {
                        if (Number(item.id) === Number(this.prizeInfo.id)) {
                            this.prizeIndex = index;
                            this.getRandomIdx();
                            this.jumpNextIndex();
                            return false;
                        }
                    });
                }
                else {
                    throw new Error('活动太火爆了，请稍后再试！');
                }
            }).catch(err => {
                this.$toast(err.message || '网络异常');
                throw new Error(err);
            });
        },
        jumpNextIndex() {
            const count = this.prizeList.length;
            this.animationPlaying = true;
            this.times++;
            this.currentIndex++;
            if (this.currentIndex  > count - 1) {
                this.currentIndex = 0;
            }
            this.judgeWithPrize();
        },
        judgeWithPrize() {
            if (this.times >  this.cycle * 8 && this.prizeIndex === this.currentIndex) {
                clearInterval(this.timer);
                this.setMyCoin(this.prizeInfo.myCoin);
                this.prizeIndex = -1;
                this.times = 0;
                this.speed = 200;
                if (this.prizeInfo.type === this.prizeInfoType.cash) {
                    this.$parent.openDialog(Const.mainDialogNum.redBag, this.prizeInfo);
                }
                else {
                    this.isShowPrizeToast = true;
                }
            }
            else {
                if (this.times < this.prizeList.length * 3) {
                    this.speed -= 10;
                }
                else {
                    this.speed += 20;
                }
                this.timer = setTimeout(this.jumpNextIndex, this.speed);
            }
        },
        // 去完成金币任务，端内关闭页面
        goToKingRoadTask() {
            closeNativePage();
        },
        // 去完成金币任务
        goToTask() {
            this.isShowLackCoinsToast = false;
            this.$emit('scrollToTaskList');
        },
        // 关闭弹窗
        closeToast() {
            this.animationPlaying = false;
            if (this.isShowLackCoinsToast) {
                this.isShowLackCoinsToast = false;
            }
            else if (this.isShowLackMedalsToast) {
                this.isShowLackMedalsToast = false;
            }
            else if (this.isShowPrizeToast) {
                this.isShowPrizeToast = false;
            }
        },
        closePrizeInfoToast() {
            this.isShowPrizeToast = false;
        },
        jumpToCouponPage() {
            const jumpUrl = 'baidumap://map/component?popRoot=no&mode=MAP_MODE&resetRoot=no&needLocation=yes'
                + '&needCloud=yes&comName=rentcar&target=rentcar_entrance'
                + '&param=%7B%22src_from%22%3A%22jiangpinzhongxin%22%7D';
            jumpByOpenapi(jumpUrl);
        }
    }
};
</script>
<style lang='scss' scoped>
.lottery-wrapper {
    position: relative;
    margin-top: 30px;

    .lottery-area {
        width: 352px;
        height: 288px;
        margin-left: 50%;
        transform: translateX(-50%);
        position: relative;
        box-sizing: border-box;
        background-size: 370px 306px;
        background-position: center;
        background-image: url('../../../assets/v2/welfare/lottery-area-bg.png');

        .lottery-item,
        .lottery-button {
            width: 112px;
            height: 90px;
            text-align: center;
            position: absolute;
            background-image: url('../../../assets/v2/welfare/lottery-item.png');
            background-size: cover;
        }

        .lottery-item-0 {
            left: 5px;
            top: 8px;
        }

        .lottery-item-1 {
            left: 119px;
            top: 8px;
        }

        .lottery-item-2 {
            left: 233px;
            top: 8px;
        }

        .lottery-item-3 {
            left: 233px;
            top: 100px;
        }

        .lottery-item-4 {
            left: 233px;
            top: 192px;
        }

        .lottery-item-5 {
            left: 119px;
            top: 192px;
        }

        .lottery-item-6 {
            left: 5px;
            top: 192px;
        }

        .lottery-item-7 {
            left: 5px;
            top: 100px;
        }

        .lottery-button {
            left: 119px;
            top: 100px;
            background-image: url(../../../assets/v2/welfare/lottery-btn.png);
        }

        .choosedItem {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            background-image: url('../../../assets/v2/welfare/selected-prize.png');
        }
    }
    .toast-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .8);
        z-index: 100;
        display: flex;
        flex-direction: column;
        align-items: center;

        .lack-coins-toast {
            width: 289px;
            height: 210px;
            margin-top: 202px;
            background: url('../../../assets/v2/welfare/lackcoin-task-toast.png');
            background-size: cover;
            display: flex;
            justify-content: center;

            .go-to-task {
                margin-top: 129px;
                width: 185px;
                height: 42px;
            }
        }

        .prize-toast {
            .prize-coupons-toast {
                width: 287px;
                height: 385px;
                display: flex;
                justify-content: center;
                margin-top: 102px;

                .coupon-toast-btn {
                    width: 185px;
                    height: 42px;
                    margin-top: 290px;
                }
            }

            .prize-coin-toast {
                width: 291px;
                height: 295px;
                margin-top: 96px;
                overflow: hidden;

                .prize-name {
                    font-size: 26px;
                    font-weight: 400;
                    font-family: PingFang SC;
                    color: #fff;
                    text-shadow: 0 0 4px #62fbff;
                    margin-top: 207px;
                    height: 19px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .prize-gift-toast {
                width: 289px;
                height: 295px;
                margin-top: 96px;
                overflow: hidden;

                .prize-name {
                    font-size: 22px;
                    font-family: PingFangSC-Medium;
                    color: #fff;
                    text-shadow: 0 0 4px #62fbff;
                    margin-top: 197px;
                    margin-left: 150px;
                    height: 19px;
                    display: flex;
                    align-items: center;
                    font-weight: 600;
                }
            }

            .prize-coin-toast,
            .prize-gift-toast,
            .prize-coupons-toast {
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
            }
        }

        .closed-btn {
            width: 28px;
            height: 28px;
            margin-top: 21px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url('../../../assets/v2/welfare/close-toast-btn.png');
        }
    }
    // 新版本
    &.v3 {
        width: calc(100% - 8px);
        margin: 47px auto 0;
        padding-bottom: 5px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid #2AE0FF;
        border-radius: 10px 0 10px 0;
        .lottery-area {
            margin: 0;
            transform: none;
            width: 361px;
            height: 295px;
            background-image: url('../../../assets/v3/welfare/lotteryBg.png');

            .lottery-item{
                width: 112px;
                height: 87px;
                position: absolute;
                background-image: none;
                background-size: cover;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .lottery-item-0 {
                left: 7px;
                top: 6px;
            }
            .lottery-item-1 {
                left: 124px;
                top: 6px;
            }
            .lottery-item-2 {
                left: 240px;
                top: 6px;
            }
            .lottery-item-3 {
                left: 240px;
                top: 100px;
            }
            .lottery-item-4 {
                left: 240px;
                top: 195px;
            }
            .lottery-item-5 {
                left: 124px;
                top: 195px;
            }
            .lottery-item-6 {
                left: 7px;
                top: 195px;
            }
            .lottery-item-7 {
                left: 7px;
                top: 100px;
            }
            .lottery-button {
                width: 107px;
                height: 87px;
                left: 128px;
                top: 104px;
                background-image: url(../../../assets/v3/welfare/lotteryBtnChecked.png);
                &.checked {
                    width: 107px;
                    height: 97px;
                    background-image: url(../../../assets/v3/welfare/lotteryBtn.png);
                }
            }


            .choosedItem {
                width: 113px;
                height: 90px;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                background-image: url('../../../assets/v3/welfare/selectBtn.png');
            }
        }
    }
    // 徽章抽奖
    &.medal {
        .lottery-title {
            width: 314px;
            height: 21px;
            margin: 31px auto 24px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url('../../../assets/v4/welfare/lotteryTitle.png');
        }
        .lottery-area {
            .lottery-button {
                left: 128px;
                top: 105px;
                background-image: url(../../../assets/v4/welfare/lotteryBtn.png);
            }
        }

        // 徽章弹窗
        .toast-mask {
            .lack-coins-toast {
                width: 307px;
                height: 201px;
                background-repeat: no-repeat;;
                background-image: url('../../../assets/v4/welfare/lackMedalToast.png');
            }
        }
    }
}
</style>